module.exports = __webpack_public_path__ + "static/media/数字化CR系统.095f1005.png";